import axios from "axios";
import settings from "utils/settings";
import filterTypes from "data/filter-types";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  LANGUAGE_LOADING,
  LANGUAGE_ADD,
  LANGUAGE_DELETE,
  LANGUAGE_LIST,
} from "./types";
import { requestCommonSearch } from "../common/requests";

const localeUrl = `${settings.localeUrl}api/`;
const ENDPOINT = "language";

export const setLoading = (status) => ({
  type: LANGUAGE_LOADING,
  payload: status
});

export const languageAdd = (id, data, callback) => dispatch => {
  dispatch(setLoading(true));
  axios
    .post(`${localeUrl}${ENDPOINT}`, data)
    .then(response => {
      dispatch({
        type: LANGUAGE_ADD,
        payload: response.data
      });
      callback(true);
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const languageDelete = (id) => dispatch => {
  dispatch(setLoading(true));
  axios
    .delete(`${localeUrl}${ENDPOINT}/${id}`)
    .then(() => {
      dispatch({
        type: LANGUAGE_DELETE,
        payload: {
          id
        }
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const languageGetList = (criteria) => dispatch => {
  dispatch(setLoading(true));
  axios
    .post(`${localeUrl}${ENDPOINT}/list`, {
      criteria
    })
    .then(response => {
      dispatch({
        type: LANGUAGE_LIST,
        payload: response
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const languageGetSearch = (
  pageNumber = 0,
  pageSize = 10,
  sort = "id,ASC",
  criteria = [],
) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, pageNumber, pageSize, sort, criteria, localeUrl)
    .then(response => {
      dispatch({
        type: LANGUAGE_LIST,
        payload: response
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const languageGetSingle = (id, callback) => dispatch => {
  dispatch(setLoading(true));
  axios
    .post(`${localeUrl}${ENDPOINT}/search?page=0&size=1`, {
      criteria: [{
        fieldName: "id",
        fieldValue: id,
        searchOperation: filterTypes.EQUALS.value
      }]
    })
    .then(response => {
      dispatch(setLoading(false));
      const res = response.data && response.data.content && response.data.content.content && response.data.content.content[0]
        ? response.data.content.content[0]
        : {};
      callback(res);
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};



// WEBPACK FOOTER //
// ./src/actions/language/requests.js